// extracted by mini-css-extract-plugin
module.exports = {"centringContainer":"Ofgre5","scrollable":"XG_Kkv","centringContent":"_2ZYYlM"};